import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import { Link } from 'react-router-dom';
import { useState } from 'react';
import { useSEO, getOrganizationSchema, getBreadcrumbSchema } from '../../utils/seo';

interface Article {
  id: string;
  title: string;
  slug: string;
  excerpt: string;
  category: string;
  readTime: string;
  image: string;
  date: string;
  author: string;
}

const mockArticles: Article[] = [
  {
    id: '1',
    title: 'Ticaret Hukukunda Yeni Düzenlemeler ve Şirketlere Etkileri',
    slug: 'ticaret-hukukunda-yeni-duzenlemeler',
    excerpt: 'Son dönemde yapılan ticaret hukuku düzenlemelerinin şirketler üzerindeki etkilerini ve uyum süreçlerini detaylı olarak inceliyoruz.',
    category: 'Ticaret Hukuku',
    readTime: '8 dk',
    image: 'https://public.readdy.ai/ai/img_res/8a7535090a9b21d2014db09889dfbd10.jpg',
    date: '15 Ocak 2024',
    author: 'Av. Yusuf Burak Çelik'
  },
  {
    id: '2',
    title: 'Gayrimenkul Alım Satımında Dikkat Edilmesi Gerekenler',
    slug: 'gayrimenkul-alim-satiminda-dikkat-edilmesi-gerekenler',
    excerpt: 'Gayrimenkul alım satım işlemlerinde karşılaşılabilecek hukuki sorunlar ve alınması gereken önlemler hakkında kapsamlı rehber.',
    category: 'Gayrimenkul Hukuku',
    readTime: '6 dk',
    image: 'https://readdy.ai/api/search-image?query=Real%20estate%20property%20documents%20with%20house%20keys%2C%20modern%20property%20contract%20signing%2C%20professional%20real%20estate%20office%2C%20dark%20navy%20and%20white%20color%20scheme%2C%20clean%20contemporary%20design&width=600&height=400&seq=article2&orientation=landscape',
    date: '12 Ocak 2024',
    author: 'Av. Yusuf Burak Çelik'
  },
  {
    id: '3',
    title: 'İş Hukukunda İşçi Hakları ve Tazminat Süreçleri',
    slug: 'is-hukukunda-isci-haklari',
    excerpt: 'İşçi haklarının korunması, kıdem ve ihbar tazminatı hesaplamaları ile iş mahkemesi süreçleri hakkında bilmeniz gerekenler.',
    category: 'İş Hukuku',
    readTime: '7 dk',
    image: 'https://readdy.ai/api/search-image?query=Employment%20law%20documents%20with%20labor%20rights%20papers%2C%20professional%20workplace%20setting%2C%20modern%20office%20environment%2C%20dark%20navy%20and%20white%20color%20scheme%2C%20clean%20professional%20design&width=600&height=400&seq=article3&orientation=landscape',
    date: '10 Ocak 2024',
    author: 'Av. Yusuf Burak Çelik'
  },
  {
    id: '4',
    title: 'Ceza Hukukunda Savunma Stratejileri',
    slug: 'ceza-hukukunda-savunma-stratejileri',
    excerpt: 'Ceza davalarında etkili savunma yöntemleri, delil toplama ve mahkeme süreçlerinde dikkat edilmesi gereken önemli noktalar.',
    category: 'Ceza Hukuku',
    readTime: '9 dk',
    image: 'https://readdy.ai/api/search-image?query=Criminal%20law%20courtroom%20with%20legal%20defense%20documents%2C%20justice%20scales%2C%20professional%20legal%20setting%2C%20dark%20navy%20and%20white%20color%20scheme%2C%20contemporary%20design&width=600&height=400&seq=article4&orientation=landscape',
    date: '8 Ocak 2024',
    author: 'Av. Yusuf Burak Çelik'
  },
  {
    id: '5',
    title: 'Aile Hukukunda Boşanma ve Velayet Davaları',
    slug: 'aile-hukukunda-bosanma-velayet',
    excerpt: 'Boşanma süreçleri, velayet hakları, nafaka hesaplamaları ve mal paylaşımı konularında detaylı bilgiler.',
    category: 'Aile Hukuku',
    readTime: '10 dk',
    image: 'https://readdy.ai/api/search-image?query=Family%20law%20documents%20with%20divorce%20papers%2C%20child%20custody%20agreements%2C%20professional%20legal%20consultation%20room%2C%20dark%20navy%20and%20white%20color%20scheme%2C%20clean%20design&width=600&height=400&seq=article5&orientation=landscape',
    date: '5 Ocak 2024',
    author: 'Av. Yusuf Burak Çelik'
  },
  {
    id: '6',
    title: 'İcra İflas Hukukunda Alacak Takibi',
    slug: 'icra-iflas-hukukunda-alacak-takibi',
    excerpt: 'Alacak tahsili için icra takibi başlatma, itiraz süreçleri ve haciz işlemleri hakkında bilmeniz gerekenler.',
    category: 'İcra İflas',
    readTime: '7 dk',
    image: 'https://readdy.ai/api/search-image?query=Debt%20collection%20legal%20documents%20with%20enforcement%20papers%2C%20professional%20legal%20office%2C%20modern%20business%20setting%2C%20dark%20navy%20and%20white%20color%20scheme%2C%20clean%20design&width=600&height=400&seq=article6&orientation=landscape',
    date: '3 Ocak 2024',
    author: 'Av. Yusuf Burak Çelik'
  },
  {
    id: '7',
    title: 'Sözleşme Hukukunda Geçersizlik Halleri',
    slug: 'sozlesme-hukukunda-gecersizlik',
    excerpt: 'Sözleşmelerin geçersiz sayılma nedenleri, iptal ve fesih süreçleri ile tazminat talepleri hakkında detaylı inceleme.',
    category: 'Sözleşme Hukuku',
    readTime: '8 dk',
    image: 'https://readdy.ai/api/search-image?query=Contract%20law%20documents%20with%20business%20agreements%2C%20professional%20contract%20signing%2C%20modern%20office%20setting%2C%20dark%20navy%20and%20white%20color%20scheme%2C%20contemporary%20design&width=600&height=400&seq=article7&orientation=landscape',
    date: '1 Ocak 2024',
    author: 'Av. Yusuf Burak Çelik'
  },
  {
    id: '8',
    title: 'Vergi Hukukunda İtiraz ve Dava Süreçleri',
    slug: 'vergi-hukukunda-itiraz-surecleri',
    excerpt: 'Vergi tarhiyatlarına itiraz yolları, uzlaşma komisyonu ve vergi mahkemesi süreçleri hakkında kapsamlı rehber.',
    category: 'Vergi Hukuku',
    readTime: '9 dk',
    image: 'https://readdy.ai/api/search-image?query=Tax%20law%20documents%20with%20financial%20papers%2C%20professional%20accounting%20office%2C%20modern%20business%20environment%2C%20dark%20navy%20and%20white%20color%20scheme%2C%20clean%20design&width=600&height=400&seq=article8&orientation=landscape',
    date: '28 Aralık 2023',
    author: 'Av. Yusuf Burak Çelik'
  },
  {
    id: '9',
    title: 'Fikri Mülkiyet Haklarının Korunması',
    slug: 'fikri-mulkiyet-haklarinin-korunmasi',
    excerpt: 'Marka, patent ve telif hakları konusunda hukuki koruma yöntemleri ve ihlal durumlarında başvuru yolları.',
    category: 'Fikri Mülkiyet',
    readTime: '7 dk',
    image: 'https://readdy.ai/api/search-image?query=Intellectual%20property%20documents%20with%20patent%20papers%2C%20trademark%20registration%2C%20professional%20legal%20office%2C%20dark%20navy%20and%20white%20color%20scheme%2C%20modern%20design&width=600&height=400&seq=article9&orientation=landscape',
    date: '25 Aralık 2023',
    author: 'Av. Yusuf Burak Çelik'
  }
];

export default function Articles() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
  
  useSEO({
    title: 'Hukuk Makaleleri Blog Isparta Yıldız & Başyiğit',
    description: 'Isparta Yıldız & Başyiğit Hukuk Bürosu blog sayfasında ticaret hukuku, gayrimenkul hukuku, aile hukuku, ceza hukuku ve iş hukuku alanlarında güncel hukuki gelişmeler, yeni düzenlemeler ve uzman görüşlerini içeren makaleler bulabilirsiniz. Hukuki bilgilerinizi artırmak ve güncel kalabilmek için makalelerimizi takip edin.',
    keywords: 'hukuk makaleleri, hukuk blogu, ticaret hukuku yazıları, gayrimenkul hukuku blog, hukuki bilgiler',
    ogImage: 'https://readdy.ai/api/search-image?query=Legal%20articles%20and%20blog%20posts%2C%20law%20library%2C%20legal%20knowledge%20sharing%2C%20professional%20legal%20writing&width=1200&height=630&seq=articles-og-image&orientation=landscape',
    canonical: `${siteUrl}/articles`,
    schema: {
      '@context': 'https://schema.org',
      '@graph': [
        getOrganizationSchema(),
        getBreadcrumbSchema([
          { name: 'Ana Sayfa', url: siteUrl },
          { name: 'Makaleler', url: `${siteUrl}/articles` }
        ]),
        {
          '@type': 'Blog',
          '@id': `${siteUrl}/articles#blog`,
          url: `${siteUrl}/articles`,
          name: 'Hukuk Makaleleri - Yıldız & Başyiğit Hukuk ve Danışmanlık',
          description: 'Hukuki konularda güncel makaleler ve uzman görüşleri',
          publisher: {
            '@id': `${siteUrl}/#organization`
          },
          blogPost: mockArticles.slice(0, 3).map(article => ({
            '@type': 'BlogPosting',
            '@id': `${siteUrl}/articles/${article.slug}`,
            headline: article.title,
            description: article.excerpt,
            datePublished: '2024-01-15',
            dateModified: '2024-01-15',
            author: {
              '@type': 'Person',
              name: article.author
            },
            publisher: {
              '@id': `${siteUrl}/#organization`
            },
            url: `${siteUrl}/articles/${article.slug}`,
            image: article.image
          }))
        },
        {
          '@type': 'ItemList',
          itemListElement: mockArticles.slice(0, 5).map((article, index) => ({
            '@type': 'ListItem',
            position: index + 1,
            item: {
              '@type': 'Article',
              '@id': `${siteUrl}/articles/${article.slug}`,
              headline: article.title,
              description: article.excerpt,
              url: `${siteUrl}/articles/${article.slug}`
            }
          }))
        }
      ]
    }
  });

  const [selectedCategory, setSelectedCategory] = useState('Tümü');
  const [visibleArticles, setVisibleArticles] = useState(6);

  const categories = ['Tümü', 'Ticaret Hukuku', 'Gayrimenkul Hukuku', 'Ceza Hukuku', 'İş Hukuku', 'Fikri Mülkiyet', 'Aile Hukuku', 'İcra İflas', 'Sözleşme Hukuku', 'Vergi Hukuku'];

  const filteredArticles = selectedCategory === 'Tümü' 
    ? mockArticles 
    : mockArticles.filter(article => article.category === selectedCategory);

  const displayedArticles = filteredArticles.slice(0, visibleArticles);
  const hasMoreArticles = visibleArticles < filteredArticles.length;

  const loadMoreArticles = () => {
    setVisibleArticles(prev => prev + 6);
  };

  const handleCategoryChange = (category: string) => {
    setSelectedCategory(category);
    setVisibleArticles(6);
  };

  return (
    <div className="min-h-screen">
      <Header />
      <main>
        {/* Hero Section */}
        <section className="bg-slate-900 text-white py-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center">
              <h1 className="text-4xl md:text-5xl font-bold mb-6 font-poppins">
                Hukuki Görüşlerimiz ve Yayınlarımız
              </h1>
              <p className="text-xl text-slate-300 max-w-3xl mx-auto font-poppins font-light">
                Güncel hukuki gelişmeler, uzman görüşlerimiz ve sektörel analizlerimiz ile hukuk dünyasındaki değişimleri takip edin
              </p>
            </div>
          </div>
        </section>

        {/* Articles Section */}
        <section className="py-16">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            {/* Category Filter */}
            <div className="flex flex-wrap justify-center gap-3 mb-12">
              {categories.map((category) => (
                <button
                  key={category}
                  onClick={() => handleCategoryChange(category)}
                  className={`px-6 py-3 rounded-full text-sm font-medium transition-colors whitespace-nowrap cursor-pointer font-poppins min-w-fit ${
                    selectedCategory === category
                      ? 'bg-slate-900 text-white' 
                      : 'bg-gray-100 text-slate-700 hover:bg-gray-200'
                  }`}
                >
                  {category}
                </button>
              ))}
            </div>

            {/* Articles Grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {displayedArticles.map((article, index) => (
                <article
                  key={article.id}
                  className="bg-white rounded-lg shadow-sm hover:shadow-lg transition-all duration-300 border border-gray-100 group animate-fade-in-up"
                  style={{ animationDelay: `${index * 0.1}s` }}
                >
                  <Link to={`/articles/${article.slug}`} className="block">
                    <div className="overflow-hidden rounded-t-lg">
                      <img
                        src={article.image}
                        alt={article.title}
                        className="w-full h-48 object-cover object-top group-hover:scale-105 transition-transform duration-300"
                      />
                    </div>
                    <div className="p-6">
                      <div className="flex items-center justify-between mb-3">
                        <span className="text-xs font-medium text-slate-900 bg-gray-100 px-3 py-1 rounded-full font-poppins">
                          {article.category}
                        </span>
                        <div className="flex items-center text-xs text-slate-500 font-poppins font-light">
                          <i className="ri-time-line mr-1"></i>
                          {article.readTime}
                        </div>
                      </div>

                      <h3 className="text-xl font-semibold text-slate-900 mb-3 leading-tight group-hover:text-slate-700 transition-colors font-poppins">
                        {article.title}
                      </h3>

                      <p className="text-sm text-slate-600 leading-relaxed mb-4 font-poppins font-light">
                        {article.excerpt}
                      </p>

                      <div className="flex items-center justify-between">
                        <span className="text-xs text-slate-500 font-poppins font-light">
                          {article.date}
                        </span>
                        <span className="text-sm font-medium text-slate-900 hover:text-slate-700 transition-colors group-hover:translate-x-1 transform duration-200 font-poppins whitespace-nowrap cursor-pointer">
                          Devamını Oku
                          <i className="ri-arrow-right-line ml-1"></i>
                        </span>
                      </div>
                    </div>
                  </Link>
                </article>
              ))}
            </div>

            {/* No Articles Message */}
            {filteredArticles.length === 0 && (
              <div className="text-center py-12">
                <i className="ri-file-text-line text-4xl text-slate-400 mb-4"></i>
                <p className="text-lg text-slate-600 font-poppins">
                  Bu kategoride henüz makale bulunmamaktadır.
                </p>
              </div>
            )}

            {/* Load More Button */}
            {hasMoreArticles && (
              <div className="text-center mt-12">
                <button 
                  onClick={loadMoreArticles}
                  className="bg-slate-900 text-white px-8 py-3 rounded-lg hover:bg-slate-800 transition-colors font-poppins font-semibold whitespace-nowrap cursor-pointer"
                >
                  Daha Fazla Makale Yükle ({filteredArticles.length - visibleArticles} makale daha)
                </button>
              </div>
            )}

            {/* All Articles Loaded Message */}
            {!hasMoreArticles && filteredArticles.length > 6 && (
              <div className="text-center mt-12">
                <p className="text-slate-600 font-poppins">
                  Tüm makaleler gösteriliyor ({filteredArticles.length} makale)
                </p>
              </div>
            )}
          </div>
        </section>

        {/* Newsletter Section */}
        <section className="bg-gray-50 py-16">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-3xl font-bold text-slate-900 mb-4 font-poppins">
              Hukuki Güncellemelerden Haberdar Olun
            </h2>
            <p className="text-lg text-slate-600 mb-8 font-poppins font-light">
              Yeni makalelerimiz ve hukuki gelişmeler hakkında bilgi almak için bültenimize abone olun
            </p>
            <div className="flex flex-col sm:flex-row gap-4 max-w-md mx-auto">
              <input
                type="email"
                placeholder="E-posta adresiniz"
                className="flex-1 px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:border-slate-900 font-poppins font-light text-sm"
              />
              <button className="bg-slate-900 text-white px-6 py-3 rounded-lg hover:bg-slate-800 transition-colors font-poppins font-semibold whitespace-nowrap cursor-pointer">
                Abone Ol
              </button>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
